import { AvailableLocale } from '@models/Lang'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { MEMBERSHIP_DEMO_TAB_TEXTS_URL } from '@utils/urls'

/** A `null` value makes the app show its built-in text for that field. */
interface DemoTabLocaleTexts {
  title: string | null
  description: string | null
}

type DemoTabTextsMap = Partial<Record<AvailableLocale, DemoTabLocaleTexts>>

interface DemoTabTexts {
  texts: DemoTabTextsMap | null
}

const fetchDemoTabTexts = () =>
  SBAPI.Fetch<DemoTabTexts>(MEMBERSHIP_DEMO_TAB_TEXTS_URL)

/**
 * Replace the demo tab texts. The API replaces the whole map, so every locale
 * must be sent with both fields, or the omitted values are cleared.
 */
const updateDemoTabTexts = (
  texts: Record<AvailableLocale, DemoTabLocaleTexts>
) => SBAPI.Put(MEMBERSHIP_DEMO_TAB_TEXTS_URL, { texts })

export { fetchDemoTabTexts, updateDemoTabTexts }
export type { DemoTabLocaleTexts, DemoTabTexts, DemoTabTextsMap }
